import React from 'react';
import ReactDatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import './style.scss';

function DatePicker({
  dateFormat, onlyPast, maxDate, selected, startDate, endDate, ...rest
}) {
  return (
    <ReactDatePicker
      customInput={null}
      dateFormat={dateFormat}
      dropdownMode="scroll"
      locale={moment.locale()}
      maxDate={onlyPast ? new Date() : maxDate}
      onKeyDown={(e) => e.preventDefault()}
      selected={selected}
      startDate={startDate}
      endDate={endDate}
      dayClassName={(date) => {
        if (startDate || endDate) {
          return '';
        }
        const dateClassname = date.toDateString() === selected?.toDateString() ? 'selected-day' : 'not-selected';
        return dateClassname;
      }}
      {...rest}
    />
  );
}

DatePicker.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onlyPast: PropTypes.bool,
  dateFormat: PropTypes.string,
  maxDate: PropTypes.string,
};

export default DatePicker;
